import React from 'react'
import { Helmet } from 'react-helmet'
import favicon from "./assets/images/favicon.ico"
import { connect } from 'react-redux'
import { store } from './index'

const Head = (props) => {

  const getCurrentState = () => {
    return store.getState()
  }

  const companyName = getCurrentState().loginData?.data?.[0]['companyname'];
  
  const headerDefaultTitle = `BIZCOMPASS® ${companyName ? `| ${companyName}` : ""}`;

  try {
    return (
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1.0" />
        <meta http-equiv="X-UA-Compatible" content="ie=edge" />
        <meta name="keywords" content="Bizcompass" />
        <meta name="author" content="Bizcompass" />
        <meta name="robots" content="Bizcompass" />
        <meta name="description" content="Bizcompass" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="Bizcompass" />

        <title>{headerDefaultTitle}</title>

        <link rel="icon" type="image/x-icon" href={favicon} />

        <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"></link>
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"></link>
        <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap" rel="stylesheet"></link>

        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" ></link>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons+Round"></link>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined"></link>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons+Sharp"></link>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons+Two%20Tone"></link>

        <link rel="stylesheet" href='https://cdn.jsdelivr.net/npm/@flaticon/flaticon-uicons@3.3.1/css/all/all.min.css'></link>
      </Helmet>
    )

  } catch (e) {
    console.log(e)
    return <></>
  }

}

const mapStateToProps = (state) => ({
  loginData: state.loginData,
});


export default connect(mapStateToProps)(Head);